export default __webpack_public_path__ + "static/media/easyToUse.36af49ac.jpg";